import { Box, Button, Container, Grid2, Typography } from "@mui/material";
import React from "react";
import Slider from "react-slick";
import { useLanguage } from "../../context/LanguageContext";

export default function BannerAbout() {
  const { language, translations } = useLanguage();
  return (
    <Box className="back-bann-211">
      <Container maxWidth="md">
        <Box className="text-center">
          <Typography variant="subtitle1" color="rgba(25, 171, 226, 1)">
            Help Center
          </Typography>
          <Typography variant="h2" sx={{ color: "#000",paddingTop:'35px' }}>
            Need a hand?
          </Typography>
          <Typography className="mt-4" sx={{ color: "rgba(0, 0, 0, 0.7)" ,lineHeight:'27.33px'}} variant="h4">
            Let us help you grow with BBCorp , check out the categories below<br/> for any questions
          </Typography>


        </Box>
      </Container>
    </Box>
  );
}